import { IFormResponseCreate, ITicketCategory, TicketIssueType, TicketStatus } from './';
import { ICustomerSpecificDataResponse, IEditAction, IPageInfo, IResidentS3File } from '../general';

export interface ITicketResidentOverviewResponse {
  edges: ITicketResidentOverviewEdge[];
  pageInfo: IPageInfo;
}

export interface ITicketResidentOverviewEdge {
  cursor: string;
  node: ITicketResidentOverview;
}

export interface ITicketResidentOverview {
  id: string;
  title: string;
  state: TicketStatus;
  category: ITicketCategory;
  created: string;
  updated: string;
  issueType: TicketIssueType;
  externalId?: string;
  archived?: boolean;
  hasUnreadMessages?: boolean;
}

export interface ITicketResidentOverviewHQ {
  id: string;
  ticketNr: string;
  title: string;
  state: TicketStatus;
  category: ITicketCategory;
  created: IEditAction;
  updated: IEditAction;
  titleImage: IResidentS3File;
  issueType: TicketIssueType;
  customerSpecificData: ICustomerSpecificDataResponse[];
  externalId?: string;
  hasUnreadMessages?: boolean;
}

export interface ITicketResidentOverviewHQResponse {
  edges: ITicketResidentOverviewHQEdge[];
  pageInfo: IPageInfo;
}

export interface ITicketResidentOverviewHQEdge {
  cursor: string;
  node: ITicketResidentOverviewHQ;
}

export enum TicketSortField {
  UPDATED = 'UPDATED',
  CREATED = 'CREATED',
}

export interface IMasterdataChangeTicket {
  formResponses: IFormResponseCreate[];
  ticketCategoryId: string;
}
